import React from 'react';

const groupData = (data, key) => {
    return data.reduce((grouped, next) => {
        grouped[next[key]] = grouped[next[key]] || [];
        grouped[next[key]].push(next);
        return grouped;
    }, {});
}

const Grouped = ({data, by, Component}) => {
    const groupedData = groupData(data, by);
    const groups = Object.keys(groupedData).map((groupKey, j) => {
        const groupData = groupedData[groupKey];
        return (
            <div className='group' key={j}>
                <h4 className='group-heading'>{groupKey}</h4>
                <div className='group-content'>
                    {groupData.map((groupElement, i) => (
                    <div key={i} className='group-list-item'>
                        <Component  {...groupElement}/>
                    </div>))}
                </div>
            </div>
        );
    });

    return (<div className='grouped'>
        {groups}
    </div>)
}

export default Grouped;